import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ThunkDispatch } from "@reduxjs/toolkit";
import {
  H1,
  Img,
  CreatedAt,
  Tags,
  TagsContainer,
  Container,
  ContentContainer,
  P,
} from "./styles";
import { format } from "date-fns";
import { ru } from "date-fns/locale";
import { fetchPostById } from "../../../store/slices/exactPostSlice";
import Footer from "../../../components/layout/Footer/Footer";
import { getPosts } from "../../../store/slices/postsSlice";
import { RootState } from "../../../store";
import { Post } from "../Post/Post";
import { Ul, Ul2 } from "../Blog/styles";

const PostDetail = () => {
  const { postId } = useParams();
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();

  // Получаем статус и ошибки из Redux store
  const getPostStatus = useSelector((state: any) => state.exactPost.status);
  const getPostError = useSelector((state: any) => state.exactPost.error);
  const exactPost = useSelector((state: any) => state.exactPost.post); // Получаем пост из стейта

  useEffect(() => {
    dispatch(fetchPostById(Number(postId)));
    dispatch(getPosts());
  }, [dispatch, postId]);

  const {
    posts,
    loading: loadingPosts,
    error: errorPosts,
  } = useSelector((state: RootState) => state.posts);

  // Проверяем статус загрузки
  if (getPostStatus === "loading") return <div>Loading...</div>;
  if (getPostStatus === "failed") return <div>Ошибка: {getPostError}</div>;

  // Проверяем, есть ли данные для отображения
  if (!exactPost) return <div>Пост не найден</div>;

  return (
    <>
      <Container>
        <CreatedAt>
          {format(new Date(exactPost.created_at), "EEEE, d MMMM, y", {
            locale: ru,
          })}
        </CreatedAt>
        <H1>{exactPost.title}</H1>
        <TagsContainer>
          {exactPost.tags &&
            exactPost.tags.map((tag) => <Tags key={tag.id}>{tag.name}</Tags>)}
        </TagsContainer>
        <ContentContainer>
          {exactPost.content.split("\n").map((paragraph, index) => (
            <>
              <P key={index}>{paragraph}</P>
              <br />
            </>
          ))}
        </ContentContainer>
      </Container>
      <H1>Читайте также</H1>
      {Array.isArray(posts) && posts.length > 0 ? (
        <Ul2>
          {posts.slice(0, 3).map((post) => {
            console.log(post.img);
            return (
              <Post
                key={post.id}
                postImg={post.img}
                postTitle={post.title}
                postCreatedAt={post.created_at}
                postTags={post.tags}
                postId={post.id}
              />
            );
          })}
        </Ul2>
      ) : (
        <></>
      )}
      <br />
      <Footer />
    </>
  );
};

export default PostDetail;
